import React, { forwardRef, useCallback } from 'react';

import styles from './styles.module.scss';
import Container from '@/components/primitives/container';
import Typography from '@/components/primitives/typography';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  header?: React.ReactNode;
  right?: React.ReactNode;
  footer?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>((props: InputProps, ref) => {
  const inputProps = { ...props };
  const [isFocused, setIsFocused] = React.useState(false);

  const onFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    props.onFocus?.call(null, e);
  }, [props.onFocus]);

  const onBlur = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    props.onBlur?.call(null, e);
  }, [props.onBlur]);

  delete inputProps.right;
  delete inputProps.onFocus;
  delete inputProps.onBlur;

  return <div className={styles.root}>
    {props.header ? <Typography size="small">{props.header}</Typography> : ''}
    <Container rootClassName={`${styles.rootContainer} ${isFocused ? styles.focused : ''}`} className={styles.container}>
      <input ref={ref} {...inputProps} onFocus={onFocus} onBlur={onBlur} />
      <div className={styles.right}>
        {!!props.right ? props.right : ''}
      </div>
    </Container>
    {props.footer ? <div className={styles.header}>{props.footer}</div> : ''}
  </div>;
});

Input.displayName = 'Input';

export default Input;